import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET_ALL: 'TEACHER_CLASS_LOGS_GET_ALL',
  GET_ALL_SUCCESS: 'TEACHER_CLASS_LOGS_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'TEACHER_CLASS_LOGS_GET_ALL_FAILURE',

  GET: 'TEACHER_CLASS_LOGS_GET',
  GET_SUCCESS: 'TEACHER_CLASS_LOGS_GET_SUCCESS',
  GET_FAILURE: 'TEACHER_CLASS_LOGS_GET_FAILURE',

  POST: 'TEACHER_CLASS_LOGS_POST',
  POST_SUCCESS: 'TEACHER_CLASS_LOGS_POST_SUCCESS',
  POST_FAILURE: 'TEACHER_CLASS_LOGS_POST_FAILURE',

  PATCH: 'TEACHER_CLASS_LOGS_PATCH',
  PATCH_SUCCESS: 'TEACHER_CLASS_LOGS_PATCH_SUCCESS',
  PATCH_FAILURE: 'TEACHER_CLASS_LOGS_PATCH_FAILURE',

  INVALIDATE_ITEM: 'TEACHER_CLASS_LOGS_INVALIDATE_ITEM',
};

export const get = actions.get(
  teacherClassroomId =>
    `${BASE_URL}/classroom/teacher-classrooms/${teacherClassroomId}/summary/`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);

export const post = actions.post(() => `${BASE_URL}/teachers/teacher-reviews/`, {
  PENDING: ACTIONS.POST,
  SUCCESS: ACTIONS.POST_SUCCESS,
  FAILURE: ACTIONS.POST_FAILURE,
});

export const patch = actions.patch(
  reviewId => `${BASE_URL}/teachers/teacher-reviews/${reviewId}/`,
  {
    PENDING: ACTIONS.PATCH,
    SUCCESS: ACTIONS.PATCH_SUCCESS,
    FAILURE: ACTIONS.PATCH_FAILURE,
  },
);

export const invalidateItem = id => dispatch => {
  dispatch({
    type: ACTIONS.INVALIDATE_ITEM,
    payload: { id },
  });
};
